import script from "./OrderAddBill.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderAddBill.vue?vue&type=script&setup=true&lang=js"

import "./OrderAddBill.vue?vue&type=style&index=0&id=cda36f50&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cda36f50"]])

export default __exports__